module.exports = __webpack_public_path__ + "static/img/s-lile.759b754.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s-lile.png
// module id = r5ic
// module chunks = 1